export default __webpack_public_path__ + "static/media/tick.9844bb96.svg";